/**
 * KAN-731 — opt-in hook for "the user tapped the nav item they are already on".
 * The shared nav (BottomTabBar, NavigationNavItems) asks the registered
 * interceptors FIRST; one returning true has handled the tap (e.g. platform:
 * "Companies" while on a company page → back to the list), so the default
 * re-tap (scroll to top / pull refresh) is skipped. With nothing registered the
 * nav behaves exactly as before. An interceptor that throws never breaks the nav.
 */
const interceptors = new Set();

/** @param {(tabKey: string) => boolean} fn @returns {() => void} unregister */
export function registerActiveTabRetapInterceptor(fn) {
  interceptors.add(fn);
  return () => { interceptors.delete(fn); };
}

/** @returns {boolean} true when an interceptor handled the re-tap */
export function interceptActiveTabRetap(tabKey) {
  for (const fn of interceptors) {
    try {
      if (fn(tabKey) === true) return true;
    } catch {
      // never let one screen's handler break the shared nav
    }
  }
  return false;
}
